import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks/useAppSelector";
import { Roles } from "../types/roles";

interface ProtectedRouteProps {
  roles?: Roles[];
  children: JSX.Element;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ roles, children, redirectTo }) => {
  const { user, isLoading } = useAppSelector(store => store.user);
  const location = useLocation();
  const from = location.state?.from || (user ? "/search" : "/");

  if (isLoading) {
    return null;
  }

  if (!roles) return children;

  const allowUnauthorized = roles.includes(Roles.Unauthorized);
  const hasRequiredRole = user && roles.some(role => user.roles.includes(role));

  if (!user) {
    return allowUnauthorized
        ? children
        : <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (hasRequiredRole) {
    return children;
  }

  if (redirectTo) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return allowUnauthorized
      ? <Navigate to={from} replace />
      : <Navigate to="/403" state={{ from: location }} replace />;
};
